import React from "react";

/** Matches Lifesavr, Lifesavrs, Lifesavr's / Lifesavr’s (any casing) */
const LIFESAVR_RE = /(Lifesavr(?:['’]s|s)?)/gi;

/** Inline brand mark — bold + italic */
const LifesavrMark = ({ children = "Lifesavr", className = "" }) => (
  <strong className={`sv-lifesavr ${className}`.trim()}>{children}</strong>
);

const wrapInString = (text, keyPrefix) => {
  if (typeof text !== "string" || !/lifesavr/i.test(text)) {
    return text;
  }

  const parts = text.split(LIFESAVR_RE);
  return parts
    .map((part, i) => {
      if (!part) return null;
      if (/^Lifesavr(?:['’]s|s)?$/i.test(part)) {
        return <LifesavrMark key={`${keyPrefix}-${i}`}>{part}</LifesavrMark>;
      }
      return part;
    })
    .filter((node) => node !== null);
};

/**
 * Wrap every Lifesavr / Lifesavr's / Lifesavrs occurrence with .sv-lifesavr.
 * Accepts a string or an array of nodes (e.g. from other highlighters).
 */
export const highlightLifesavr = (input) => {
  if (typeof input === "string") {
    return wrapInString(input, "ls");
  }

  if (Array.isArray(input)) {
    return input.flatMap((node, i) => {
      if (typeof node !== "string") return [node];
      const wrapped = wrapInString(node, `ls-${i}`);
      return Array.isArray(wrapped) ? wrapped : [wrapped];
    });
  }

  return input;
};

export default LifesavrMark;
